import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Form, Input, Label, Row, Button } from 'reactstrap';
import { fetchCustomersRequest } from 'store/actions';
import CustomerTable from './CustomersTable';
import Breadcrumb from 'components/Common/Breadcrumb2';

const CustomerList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const customers = useSelector((state) => state.Customer.customers);
    const totalCount = useSelector((state) => state.Customer.totalCount);
    const loading = useSelector((state) => state.Customer.loading);
    const error = useSelector((state) => state.Customer.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sorting, setSorting] = useState([{ id: 'customerNameEng', desc: false }]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchVal, setSearchVal] = useState("");

    const getColumnIndex = (accessorKey) => {
        const mapping = {
            'customerNameEng': 0,
            'customerNameAr': 1,
            'contractNumber': 2,
            'contractId': 3,
            'subscriberNumber': 4,
            'contactNumber1': 5,
            'contactNumber2': 6,
            'nationality1': 7,
            'isActive': 8
        };
        return mapping[accessorKey] !== undefined ? mapping[accessorKey] : 0;
    };

    useEffect(() => {
        const sortColId = sorting[0]?.id || 'customerNameEng';
        const sortCol = getColumnIndex(sortColId);
        const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';

        dispatch(fetchCustomersRequest(pageSize, pageIndex * pageSize, sortCol, sortDir, searchTerm));
    }, [dispatch, pageIndex, pageSize, sorting, searchTerm]);

    const handleSearch = () => {
        setPageIndex(0);
        setSearchTerm(searchVal);
    };

    return (
        <>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3 ">
                    <Breadcrumb title="Customers" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Customers", link: '#' }]} />
                    {permissions?.map(item => item?.permissionName)?.includes("Add Customers") && <Button
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                        onClick={() => navigate('/createCustomer', { state: { from: window.location.pathname } })}
                    >
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>

                <div className='filters-section mx-3'>
                    <Form className="my-3">
                        <Row className="g-3">
                            <Col xs={12} md={6} lg={4}>
                                <Label for="searchField">Search</Label>
                                <Input
                                    type="text"
                                    id="searchField"
                                    placeholder="Search Customer Name, Contact, Civil ID..."
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>
                            <Col xs={12} md={2} className='d-flex justify-start align-center'>
                                <Button color="primary mt-auto" style={{ marginBottom: '2px' }} onClick={handleSearch}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <CustomerTable 
                    loading={loading} 
                    List={customers?.Data} 
                    totalCount={totalCount}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    sorting={sorting}
                    onPaginationChange={(state) => {
                        setPageIndex(state.pageIndex);
                        setPageSize(state.pageSize);
                    }}
                    onSortingChange={setSorting}
                    onGlobalFilterChange={setSearchTerm}
                />
            </div>
        </>
    );
};

export default CustomerList;
